import { makeStyles } from '@mui/styles';
import { theme } from '~/theme/default';
export const useStyles = makeStyles(() => ({
    circleContainer: {
        backgroundColor: theme.palette.warning.main,
        borderRadius: '100px',
        height: '17px',
        width: '17px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    counterNumber: {
        fontSize: '11px',
        fontWeight: 500,
        textAlign: 'center',
        color: theme.palette.text.white,
    },
}));
